import { useEffect, useState } from "react";
import { FileDown, Share2, Printer, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { fetchBlob, saveBlob, errMsg } from "@/lib/api";
import { tr as t } from "@/lib/i18n";

export default function PdfActions({ path, filename, label: rawLabel = "الفاتورة PDF", testid = "pdf" }) {
  const label = t(rawLabel);
  const [blob, setBlob] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    let on = true;
    setBlob(null);
    fetchBlob(path).then((b) => on && setBlob(b)).catch((e) => { setErr(true); toast.error(errMsg(e)); });
    return () => { on = false; };
  }, [path]);

  const file = blob ? new File([blob], filename, { type: "application/pdf" }) : null;
  const canShare = file && navigator.canShare && navigator.canShare({ files: [file] });

  const open = () => {
    const url = URL.createObjectURL(blob);
    const w = window.open(url, "_blank");
    if (!w) saveBlob(blob, filename);
  };
  const share = async () => {
    try { await navigator.share({ files: [file], title: filename }); } catch (e) { if (e.name !== "AbortError") saveBlob(blob, filename); }
  };

  if (err) return <div className="text-red-600 font-bold">{t("تعذر تجهيز {l}", { l: label })}</div>;
  if (!blob) return <div className="flex items-center gap-2 text-slate-500" data-testid={`${testid}-loading`}><Loader2 className="w-5 h-5 animate-spin" />{t("جاري تجهيز {l}...", { l: label })}</div>;
  return (
    <div className="grid grid-cols-3 gap-2">
      <button data-testid={`${testid}-open`} onClick={open} className="btn btn-md btn-ghost"><Printer className="w-5 h-5" />{t("طباعة")}</button>
      <button data-testid={`${testid}-share`} onClick={canShare ? share : () => saveBlob(blob, filename)} className="btn btn-md btn-green">
        <Share2 className="w-5 h-5" />{canShare ? t("مشاركة") : t("واتساب")}</button>
      <button data-testid={`${testid}-download`} onClick={() => saveBlob(blob, filename)} className="btn btn-md btn-ghost"><FileDown className="w-5 h-5" />{t("تنزيل")}</button>
    </div>
  );
}
